import React, { useCallback, useEffect, useState } from "react";
import Dropdown from "../../../../components/common/dropdown";
import Button from "../../../../components/common/button";
import { LoadingOutlined } from "@ant-design/icons";
import { colors } from "../../../../share/constants/enums";
import {
  Avatar,
  Form,
  Input,
  Input as InputField,
  InputNumber,
  Spin,
  message,
} from "antd";
import { updatePersonalSettings, uploadImage } from "../../../../api/settings";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusiness } from "../../../../store/slices/businessSlice";
import { updateCompanyDetails } from "../../../../api/settings";
import { fetchUsers } from "../../../../store/slices/userSlice";
import { useOutletContext } from "react-router-dom";
import Checkbox from "../../../../components/common/checkBox";
import PhoneInput from "../../../../components/common/handlePhoneInput";
import { PlusOutlined } from "@ant-design/icons";
import ImageUpload from "../../../../components/common/imageModal";
import { convertURLToFile } from "../../../../share/utils";

const Personalsettings = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [cloader, setCloader] = useState(false);
  const [checkValue, setCheckValue] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState();
  const [iloader, setIloader] = useState(false);
  const [renderOnChange, SetRenderOnChange] = useState(false);
  const dataUser = useOutletContext();
  const dispatch = useDispatch();
  const [imageModal, setImageModal] = useState(false);
  const [statImage, setStatImage] = useState(null);

  const businessLoader = useSelector((state) => {
    return state.business;
  });
  const businessData = useSelector((state) => {
    return state.business?.business;
  });

  const userData = useSelector((state) => {
    return state.user;
  });

  const imageUploadModal = (id) => {
    setImageModal(true);
  };
  const hideModal = () => {
    setImageModal(false);
  };

  const handleChangeAndUploadImage = async (e) => {
    setIloader(true);
    const file = e.target.files[0];
    const createImageUrl = URL.createObjectURL(file);
    setStatImage(createImageUrl);
    imageUploadModal();
  };

  const handleUploadTos3 = async (file, rotationOfCroppedImage) => {
    const uploadedFile = await convertURLToFile(file?.imgSrc);

    if (uploadedFile) {
      let rotatedImageBlob = uploadedFile; // Initialize rotated image blob with original image

      // Rotate the image if rotation angle is provided
      if (rotationOfCroppedImage !== 0) {
        rotatedImageBlob = await rotateImage(
          uploadedFile,
          rotationOfCroppedImage
        );
      }

      const formData = new FormData();
      formData.append("image", rotatedImageBlob); // Append rotated image blob to form data

      try {
        const response = await uploadImage(formData);
        if (response) {
          setProfilePhoto(dataUser?.profileImage);
          message.success("Your image has been updated");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setIloader(false);
        setImageModal(false);
      }
    } else {
      setIloader(false);
    }
  };
  // Function to rotate image using client-side JavaScript
  const rotateImage = (imageFile, rotationAngle) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Set canvas dimensions considering rotation
        canvas.width = rotationAngle % 180 === 0 ? img.width : img.height;
        canvas.height = rotationAngle % 180 === 0 ? img.height : img.width;

        // Rotate and draw image onto canvas
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((rotationAngle * Math.PI) / 180);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);

        // Convert canvas to blob
        canvas.toBlob((blob) => {
          resolve(blob);
        }, "image/jpeg");
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(imageFile);
    });
  };

  const onFinish = async (values) => {
    const payload = {
      firstName: values.firstName || userData?.response?.firstName || "",
      lastName: values.lastName || userData?.response?.lastName || "",
      phoneNumber: values.phoneNumber || userData?.response?.phoneNumber || "",
    };
    try {
      setLoader(true);
      form.validateFields();
      const res = await updatePersonalSettings(payload);
      if (res) {
        SetRenderOnChange(!renderOnChange);
        message.success("Your updates have been saved");
      }
    } catch (e) {
      message.error(e);
    } finally {
      setLoader(false);
    }
  };

  const onFinishBusiness = async (values) => {
    const payload = {
      businessName: values.businessName || businessData?.businessName || "",
      isAcceptAppointments: checkValue,
      businessAddress:
        values.businessAddress || businessData?.businessAddress || "",
      website: values?.website || businessData?.website || "",
      yearsInBusiness:
        values.yearsInBusiness || businessData?.yearsInBusiness || "",
      staffSize: values.staffSize || businessData?.staffSize || "",
    };

    try {
      setCloader(true);
      form.validateFields();
      const businessRes = await updateCompanyDetails(payload);
      if (businessRes) {
        message.success("Your Company details have been updated!");
      }
    } catch (e) {
      message.error(e);
    } finally {
      setCloader(false);
    }
  };

  const fetchData = useCallback(async () => {
    dispatch(fetchBusiness());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchUsers());
    fetchData();
  }, [profilePhoto, renderOnChange, fetchData, dispatch]);

  return (
    <>
      {businessLoader?.isLoading ? (
        <div className="h-screen w-full flex items-center justify-center">
          <Spin indicator={<LoadingOutlined />} />
        </div>
      ) : (
        <div className="px-3 pb-2">
          <div className="flex items-center mt-3">
            <label
              htmlFor="imageUpload"
              className="flex flex-col cursor-pointer border-solid border-inputFieldGrey rounded-md group-hover:text-white justify-center h-8 w-24.6 items-center bg-white hover:text-white text-primaryPurple border hover:bg-primaryPurple"
            >
              <PlusOutlined
                className="justify-center"
                style={{ fontSize: "18px" }}
              />
              Change Avatar
              <Input
                type="file"
                id="imageUpload"
                accept="image/*"
                className="h-8.7 w-24.6"
                style={{ display: "none" }}
                onChange={handleChangeAndUploadImage}
              />
            </label>
            <div className="ml-2">
              {iloader ? (
                <div className="loader">
                  <Spin indicator={<LoadingOutlined />} />
                </div>
              ) : (
                <Avatar className="mr-1 w-8 h-8" src={dataUser?.profileImage} />
              )}
            </div>
          </div>

          <div>
            <p className="text-lg font-medium tracking-wider">
              Personal Details
            </p>
          </div>

          <div className="border-solid border-inputFieldGrey rounded-sm p-2 lg:col-span-2 lg:px-5">
            <Form className="w-full xl:content-start" onFinish={onFinish}>
              <div className="w-full xl:grid xl:grid-cols-4 xl:gap-2 xl:content-start">
                <Form.Item name="firstName" className="">
                  <InputField
                    className="hover:border-primaryBlue h-5.4"
                    defaultValue={userData?.response?.firstName}
                    placeholder="First Name"
                  />
                </Form.Item>
                <Form.Item name="lastName" className="w-full">
                  <InputField
                    className={"w-full  hover:border-primaryBlue h-5.4 "}
                    defaultValue={userData?.response?.lastName}
                    placeholder="Last Name"
                  />
                </Form.Item>
                <Form.Item name="Email " disabled className="w-full">
                  <InputField
                    className={"w-full hover:border-primaryBlue h-5.4 "}
                    defaultValue={userData?.response?.email}
                    disabled
                  />
                </Form.Item>
                <Form.Item
                  name="phoneNumber"
                  initialValue={userData?.response?.phoneNumber}
                  rules={[
                    {
                      pattern: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
                      message: "Please add correct Number",
                    },
                    {
                      required: true,
                      message: "field is required",
                    },
                  ]}
                >
                  <PhoneInput value={userData?.response?.phoneNumber} />
                </Form.Item>
              </div>
              <Form.Item>
                <div className="w-full flex justify-center lg:justify-end ">
                  <Button
                    color={colors.primaryPurple}
                    title="Save"
                    htmlType="submit"
                    loading={loader}
                    className="w-19"
                  />
                </div>
              </Form.Item>
            </Form>
          </div>
          {businessData?.isLoading ? (
            <div className="h-screen w-full flex items-center justify-center">
              <Spin />
            </div>
          ) : (
            <>
              <p className="text-lg font-medium tracking-wider">
                Company Details
              </p>
              <div className="border-solid border-inputFieldGrey rounded-sm p-2 lg:col-span-2 lg:px-5">
                <Form onFinish={onFinishBusiness}>
                  <div className="w-full xl:grid xl:grid-cols-4 xl:gap-2 xl:content-start">
                    <Form.Item
                      name="Business Type"
                      className="w-full bg-inputFieldGrey rounded-md "
                      disabled={true}
                    >
                      <Dropdown
                        defaultValue={businessData?.businessTypeId?.name}
                        disabled={true}
                      />
                    </Form.Item>

                    <Form.Item name="businessName">
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4 "}
                        defaultValue={businessData?.businessName}
                        placeholder="Business Name"
                      />
                    </Form.Item>
                    <Form.Item name="businessAddress">
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4 "}
                        defaultValue={businessData?.businessAddress}
                        placeholder="Business Address"
                      />
                    </Form.Item>
                    <Form.Item name="website">
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4 "}
                        defaultValue={businessData?.website}
                        placeholder="Website"
                      />
                    </Form.Item>
                    <Form.Item
                      name="yearsInBusiness"
                      rules={[
                        {
                          pattern: /^(0*[0-9]\d*(\.\d+)?|0+\.\d*[0-9]\d*)$/,
                          message: "Please enter a positive number",
                        },
                      ]}
                    >
                      <InputNumber
                        className={
                          "w-full hover:border-primaryBlue flex items-center h-5.4 "
                        }
                        controls={false}
                        type="number"
                        placeholder="Years in Business"
                        defaultValue={businessData?.yearsInBusiness}
                      />
                    </Form.Item>
                    <Form.Item
                      name="staffSize"
                      rules={[
                        {
                          pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                          message: "Please enter a positive number",
                        },
                      ]}
                    >
                      <InputNumber
                        className={
                          "w-full  hover:border-primaryBlue flex items-center h-5.4 "
                        }
                        controls={false}
                        type="number"
                        placeholder="Staff Size"
                        defaultValue={businessData?.staffSize}
                      />
                    </Form.Item>
                    <Form.Item name="isAcceptAppointments"></Form.Item>
                  </div>
                  <div className="w-full flex flex-col items-center justify-center lg:grid lg:grid-cols-2">
                    <Form.Item className="lg:flex" name="t&c">
                      <Checkbox
                        onChecked={(value) => {
                          setCheckValue(value);
                        }}
                        description="Does your Business Accept Appointments? "
                      />
                    </Form.Item>
                    <Form.Item className="lg:w-full lg:flex lg:justify-end">
                      <Button
                        color={colors.primaryPurple}
                        title="Save"
                        htmlType="submit"
                        loading={cloader}
                        className="w-19"
                      />
                    </Form.Item>
                  </div>
                </Form>
              </div>
            </>
          )}
          <div>
            {imageModal && (
              <ImageUpload
                statImage={statImage}
                // id={selectedId}
                title="Image Modal"
                handleUploadTos3={handleUploadTos3}
                // text="Are you sure you want to delete ticket?"
                onCancel={hideModal}
                // onOk={YesClickHandler}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Personalsettings;
